import { isset } from 'src/util/Util.js';
import moment from 'moment';

const mixinUpdateRow = {
  methods: {
    updateRow(updateData) {
      const { data: responseUpdated, message } = updateData.data;
      const { labor_header: updatedHeader } = responseUpdated;
      const inTable = { ...this.tableDataDetails[this.model.index] };
      const { labor_header: currentHeader } = inTable;

      const changeWorker =
        updatedHeader['worker_id'] === currentHeader['worker_id'];
      const changeDate =
        moment(currentHeader['date_save']).format('YYYY-MM-DD') ===
        moment(updatedHeader['date_save']).format('YYYY-MM-DD');
      const changeFarm = updatedHeader['farm_id'] === currentHeader['farm_id'];

      if (changeWorker && changeDate && changeFarm) {
        return this.updateRowDetails(inTable, responseUpdated, message);
      }

      const shouldDelete = this.shouldDeleteRow(updatedHeader);
      const detailLength = this.tableDataDetails.length;
      const isSameHeader = updatedHeader.id === this.rowData.id;

      if (shouldDelete && detailLength === 1) {
        this.deleteAndUpdateTable();
      } else if (!isSameHeader && detailLength > 1) {
        this.handleDifferentHeaderMultipleDetails(
          updatedHeader,
          responseUpdated,
          shouldDelete
        );
      } else if (!isSameHeader && detailLength === 1) {
        this.handleDifferentHeaderSingleDetail(
          updatedHeader,
          responseUpdated,
          shouldDelete
        );
      } else {
        this.updateRowDetails(inTable, responseUpdated, message);
      }
    },

    shouldDeleteRow(updatedHeader) {
      const { farm_id, worker_id, date_save } = updatedHeader;

      const validateFarm = !isset(this.dataFilter.farm)
        ? true
        : [
            ...this.tableData.map((row) => row.farm_id),
            ...this.dataFilter.farm,
          ].includes(farm_id);

      const validateWorker = !isset(this.dataFilter.workers)
        ? true
        : [
            ...this.tableData.map((row) => row.worker_id),
            ...this.dataFilter.workers,
          ].includes(worker_id);

      const validateDate = moment(date_save).isBetween(
        moment(`${this.dataFilter.datei} 00:00:00`),
        moment(`${this.dataFilter.datef} 23:59:59`),
        null,
        '[]'
      );

      return !validateFarm || !validateWorker || !validateDate;
    },

    deleteAndUpdateTable() {
      this.rowData.deleteHeader = true;
      this.handleViewDetails();
      this.updateTableAfterDelete(this.model.index, false);
    },

    handleDifferentHeaderMultipleDetails(
      updatedHeader,
      responseUpdated,
      shouldDelete
    ) {
      this.updateTableAfterDelete(this.model.index);

      if (!shouldDelete) {
        this.updateOrAddTableData(updatedHeader, responseUpdated);
      }
    },

    handleDifferentHeaderSingleDetail(
      updatedHeader,
      responseUpdated,
      shouldDelete
    ) {
      this.deleteAndUpdateTable();

      if (!shouldDelete) {
        this.updateOrAddTableData(updatedHeader, responseUpdated);
      }
    },

    updateOrAddTableData(updatedHeader, responseUpdated) {
      const newDetails = { ...responseUpdated };
      delete newDetails.labor_header;

      const index = this.tableData.findIndex(
        (row) => row.id === updatedHeader.id
      );

      if (index !== -1) {
        const laborDetails = [...this.tableData[index].labor_details];
        laborDetails.push(newDetails);

        this.tableData[index] = {
          ...this.tableData[index],
          ...updatedHeader,
          labor_details: laborDetails,
        };
      } else {
        this.tableData.push({
          ...updatedHeader,
          labor_details: [newDetails],
        });
      }
    },
  },
};

export default mixinUpdateRow;
